export default function useEvent() {
  const { proxy } = useGA4()
  const { locale } = useI18n()
  const route = useRoute()

  function sendNewRegistrationEvent(country: string) {
    proxy.gtag('event', 'new_registration', {
      country,
      locale: locale.value,
    })
  }

  function sendNeedHelpEvent(productTitle: string) {
    proxy.gtag('event', 'need_help', {
      product_title: productTitle,
      locale: locale.value,
    })
  }

  function sendNeedHelpSentEvent(productTitle: string) {
    proxy.gtag('event', 'need_help_sent', {
      product_title: productTitle,
      locale: locale.value,
    })
  }

  function sendCustomiseYourChairEvent(productTitle: string) {
    proxy.gtag('event', 'customise_your_chair', {
      product_title: productTitle,
      locale: locale.value,
    })
  }

  function sendEnquireEvent(productTitle: string, isConfigurator: boolean) {
    proxy.gtag('event', 'enquire', {
      product_title: productTitle,
      locale: locale.value,
      is_configurator: isConfigurator,
    })
  }

  function sendEnquireSentEvent(productTitle: string, isConfigurator: boolean) {
    proxy.gtag('event', 'enquire', {
      product_title: productTitle,
      locale: locale.value,
      is_configurator: isConfigurator,
    })
  }

  function sendSearchEvent(query: string) {
    proxy.gtag('event', 'search', {
      query,
      locale: locale.value,
      path: route.path,
      page_title: import.meta.client ? document.title : '',
    })
  }

  function sendSignedUpForUpdatesEvent(country: string) {
    proxy.gtag('event', 'signed_up_for_updates', {
      country,
      locale: locale.value,
      path: route.path,
      page_title: import.meta.client ? document.title : '',
    })
  }

  return {
    sendNewRegistrationEvent,
    sendNeedHelpEvent,
    sendNeedHelpSentEvent,
    sendCustomiseYourChairEvent,
    sendEnquireEvent,
    sendEnquireSentEvent,
    sendSearchEvent,
    sendSignedUpForUpdatesEvent,
  }
}
